var a = /* @__PURE__ */ ((n) => (n.info = "info", n.success = "success", n.warning = "warning", n.alert = "alert", n.neutral = "neutral", n.brand = "brand", n))(a || {});
const c = (n) => {
  switch (n) {
    case "alert":
      return "notification-interim-alert";
    case "success":
      return "notification-interim-success";
    case "warning":
      return "notification-interim-warning";
    case "neutral":
      return "notification-interim-neutral";
    case "brand":
      return "notification-interim-brand";
    case "info":
    default:
      return "notification-interim-info";
  }
}, o = (n, i) => !i && (n === "neutral" || n === "brand") ? "notification-interim-without-icon" : "", l = (n) => {
  const i = "notification-interim", t = c(n.type), e = o(n.type, n.icon), s = n.inline ? "notification-interim-inline" : "", r = n.notDismissible ? "notification-interim-not-dismissible" : "";
  return `${i} ${t} ${e} ${s} ${r}`;
}, u = (n, i) => {
  switch (n) {
    case "alert":
      return "alert";
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "info":
      return "information";
    case "neutral":
    case "brand":
    default:
      return i;
  }
};
export {
  a as NotificationTypeEnum,
  u as getNotificationIcon,
  l as getNotificationStyleClasses
};
